"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FREQUENCY_PERIOD = exports.DAILY_DIGEST_NOTIFICATION = void 0;
exports.DAILY_DIGEST_NOTIFICATION = 'dailyDigestNotification';
exports.FREQUENCY_PERIOD = 24; //in hours
